export const general: GeneralSetup = {
    canonicalUrl: 'https://kromatic.com/tools/innovation-accounting-app',
    documentDescription:
        "Practice innovation accounting with Kromatic's food truck simulation. Build a financial model, test revenue predictions with real data, estimate with ranges, and model growth.",
    documentTitle: 'Innovation Accounting Simulation - Kromatic',
    favicon: '/favicon.png',
    faq: [
        {
            question: 'What is the Innovation Accounting Simulation?',
            answer:
                'The Innovation Accounting Simulation is an interactive food truck exercise that teaches you how to make better predictions about revenue, ROI, and business growth.',
        },
        {
            question: 'What do you do in the simulation?',
            answer:
                'You play an aspiring chef, pitch a bank for funding, build a step-by-step financial model, and update your predictions as you gather more evidence about the business.',
        },
        {
            question: 'Why does the simulation break the business into smaller steps?',
            answer:
                'Breaking the model into smaller steps makes assumptions easier to understand, measure, and improve than trying to predict a single revenue number all at once.',
        },
        {
            question: 'Why does the simulation use ranges instead of a single prediction?',
            answer:
                'Ranges are less precise but more realistic. They show uncertainty, help account for outliers, and make it easier to explain best and worst case outcomes.',
        },
        {
            question: 'How does the simulation improve predictions?',
            answer:
                'The simulation uses qualitative insight, real data, and growth loops to refine each assumption so the overall revenue prediction becomes more accurate over time.',
        },
    ],
    portionMarking: null,
    siteName: 'Kromatic',
    socialDescription:
        "Use Kromatic's food truck simulation to practice innovation accounting, improve revenue predictions, estimate with ranges, and model growth.",
    socialImage: 'https://kromatic.com/tools/innovation-accounting-app/assets/images/truck-illustration.png',
    socialImageAlt: 'Innovation Accounting Simulation with a banker, coach, and food truck',
    socialTitle: 'Innovation Accounting Simulation | Kromatic',
};
